import { Card, Col, Row, Tabs } from "antd";
import ListImages from "./images/ListImages";


function ThemeImages() {
  const tabItems = [
    {
      key: "images",
      label: "Images",
      children: <ListImages folder_name="images" />,
    },
  ];

  return (
    <div className="lms-body">
      <Card>
        <h2>Culsight Images</h2>

        <Row style={{ marginTop: 24 }}>
          <Col span={24}>
            <Tabs defaultActiveKey="images" items={tabItems} />
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default ThemeImages;